import { Flex, FlexProps } from '@chakra-ui/react';
import { Helmet } from 'react-helmet-async';

import { useOnRouteScrollTo } from '../hooks/useOnRouteScrollTo';

interface Props extends FlexProps {
  title?: string;
  withHeader?: boolean;
}

export const Page = ({ title, children, ...rest }: Props) => {
  const ref = useOnRouteScrollTo(0, 0);

  return (
    <Flex direction="row" h="100vh" flex={1} overflowY="hidden" {...rest} ref={ref as any}>
      <Helmet>
        <title>{title ? `${title} • ` : ''}Pelicargo Admin</title>
      </Helmet>
      {children}
    </Flex>
  );
};
